export default __webpack_public_path__ + "static/media/white_subscription.769c693d.svg";